export default __webpack_public_path__ + "static/media/chevron.bf760cb3.svg";